import React from "react";

class TearmsAndCondition extends React.Component {
  render() {
    return (
      <>
        <section id="breadcrumbs" className="breadcrumbs">
          <div className="container"></div>
        </section>

        <section id="PrivacyPolicy" className="PrivacyPolicy">
          <div className="container">
            <div className="section-title" data-aos="fade-up">
              <h2>Terms and Conditions</h2>
            </div>

            <div className="row content">
              <div className="col-lg-12" data-aos="fade-up" data-aos-delay="150">

                {/* <p><strong>Last Updated: 27-Nov-2025</strong></p> */}

                <p>
                  These Terms and Conditions (“Terms”) govern the use of services
                  provided by <strong>AGM Etech Private Limited</strong>
                  (“Company”, “we”, “us”, or “our”). By accessing our website or
                  engaging our services, you (“Client”, “you”, or “your”) agree
                  to these Terms.
                </p>

                <h4>1. Services Provided</h4>
                <ul>
                  <li>Web Application Development</li>
                  <li>Mobile Application Development (Android / iOS / Cross-platform)</li>
                  <li>Customised Software Development</li>
                  <li>Website Design and Development</li>
                  <li>Maintenance, Support, and Consulting Services</li>
                </ul>

                <h4>2. Project Scope & Changes</h4>
                <ul>
                  <li>Any work outside the agreed scope is treated as a Change Request.</li>
                  <li>Additional charges and revised timelines may apply.</li>
                  <li>All changes must be approved in writing before execution.</li>
                </ul>

                <h4>3. Payment Terms</h4>
                <ul>
                  <li>Payments are as per the agreed quotation or invoice.</li>
                  <li>Advance payments are non-refundable.</li>
                  <li>Delayed payments may result in project suspension.</li>
                  <li>Applicable taxes (including GST) apply as per Indian law.</li>
                </ul>

                <h4>4. Client Responsibilities</h4>
                <ul>
                  <li>Provide clear, accurate requirements and timely approvals.</li>
                  <li>Ensure shared materials do not infringe third-party rights.</li>
                  <li>Assign a single point of contact for communication.</li>
                </ul>

                <h4>5. Intellectual Property Rights</h4>
                <ul>
                  <li>Upon full payment, ownership of final deliverables transfers to the Client.</li>
                  <li>Pre-existing tools, frameworks, and third-party components remain Company property.</li>
                  <li>Completed projects may be showcased unless restricted by NDA.</li>
                </ul>

                <h4>6. Confidentiality</h4>
                <p>
                  Both parties agree to maintain confidentiality of all proprietary,
                  technical, and business information shared during the engagement.
                </p>

                <h4>7. Third-Party Services</h4>
                <ul>
                  <li>Use of third-party services is at the Client’s risk.</li>
                  <li>Third-party service costs are borne by the Client unless agreed otherwise.</li>
                </ul>

                <h4>8. Warranty & Disclaimer</h4>
                <p>
                  All services are provided on an “as-is” basis. The Company does
                  not guarantee business results, revenue, or performance outcomes.
                </p>

                <h4>9. Limitation of Liability</h4>
                <ul>
                  <li>The Company is not liable for indirect or consequential damages.</li>
                  <li>Total liability shall not exceed the amount paid for the service.</li>
                </ul>

                <h4>10. Maintenance & Support</h4>
                <p>
                  Maintenance and support services are provided only if included
                  in the agreement or purchased separately. New features or major
                  enhancements are excluded unless agreed.
                </p>

                <h4>11. Termination</h4>
                <ul>
                  <li>Either party may terminate in case of uncured material breach.</li>
                  <li>Payments made are non-refundable.</li>
                  <li>Completed work up to termination will be invoiced.</li>
                </ul>

                <h4>12. Force Majeure</h4>
                <p>
                  Neither party shall be liable for delays caused by events beyond
                  reasonable control including natural disasters, government actions,
                  or internet outages.
                </p>

                <h4>13. Governing Law & Jurisdiction</h4>
                <p>
                  These Terms are governed by the laws of India. Any disputes shall
                  be subject to the courts of Ahmedabad, Gujarat, India.
                </p>

                <h4>14. Amendments</h4>
                <p>
                  The Company reserves the right to modify these Terms at any time.
                  Continued use of services constitutes acceptance of revised Terms.
                </p>

                <h4>15. Contact Information</h4>
                <p><strong>AGM Etech Private Limited</strong></p>
                <p>429, S.V. Square, New Ranip, Ahmedabad – 382470, Gujarat, India</p>
                <p>Email: paresh@agmetech.com</p>
                <p>Phone: +91 97123 12188</p>
                <p>Website: www.agmetech.com</p>

              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default TearmsAndCondition;
